// function Quiz(quizContainer, questions) {
//     return {
//         step: 0,
//         data : {},
//         stepUp: function () {
//             this.step = this.step + 1 <= questions.length ? this.step + 1 : this.step;
//             this.render();
//         },
//         stepDown: function () {
//             this.step = this.step - 1 >= 0 ? this.step - 1 : this.step;
//             this.render();
//         },
//         render: function () {
//             // render all questions first then hide all. Show only the current step
//             let html = '';
//             questions.forEach((question, index) => {
//                 html += `
//                 <div class="question d-none ${this.step === index ? 'd-block' : ''}">
//                     <div class="question-title">${question.question}</div>
//                     <div class="question-answers">
//                         ${question.answers.map(answer => `
//                             <div class="question-answer">
//                                 ${
//                                     question.type == "single" ?
//                                         `<label ><input type="radio" name="question-${index}" value="${answer}" onclick=${
//                                             this.data[`question-${index}`] = answer
//                                         } /> ${answer}</label>`
//                                         :
//                                         `<label ><input type="checkbox" name="question-${index}" value="${answer}" onclick=${
//                                             this.data[`question-${index}`] = [...this.data[`question-${index}`] || [], answer]
//                                         } /> ${answer}</label>`
//                                 }
//                             </div>
//                         `).join('')}
//                     </div>
//                 </div>
//             `;
//             }
//             );
//             quizContainer.innerHTML = html;
//             // show/hide buttons
//             if (this.step === 0) {
//                 prevBtn.style.display = 'none';
//             } else {
//                 prevBtn.style.display = 'inline-block';
//             }
//             if (this.step === questions.length) {
//                 nextBtn.style.display = 'none';
//                 submitBtn.style.display = 'inline-block';
//                 quizInputs.style.display = 'flex';
//             } else {
//                 nextBtn.style.display = 'inline-block';
//                 submitBtn.style.display = 'none';
//                 quizInputs.style.display = 'none';
//             }


//         },
//     };
// }

// //   let questions = document.querySelector('#quiz-questions').value;
// console.log('questions', questions);
// console.log('questions', JSON.parse(questions));
// const jsonQuestions = JSON.parse(questions);
// let quizContainer = document.querySelector('.quiz-root');
// let quizInputs = document.querySelector('.quiz-form-inputs');
// let nextBtn = document.querySelector('#next-btn');
// let prevBtn = document.querySelector('#prev-btn');
// let submitBtn = document.querySelector('#submit-btn'); // default : display none

// if (jsonQuestions.length > 0) {
//     let quiz = new Quiz(quizContainer, jsonQuestions);
//     quiz.render();
//     nextBtn.addEventListener('click', function () {
//         quiz.stepUp();
//     }
//     );
//     prevBtn.addEventListener('click', function () {
//         quiz.stepDown();
//     }
//     );

//     const form = document.querySelector(".quiz-form")
// function formOnsubmit(e){
//     e.preventDefault();
//     console.log("Quiz data",quiz.data)
//     console.log('formOnsubmit', e);
//     const formData = new FormData(form);
//     console.log('formData', formData);
//     console.log("formData.entries()", formData.entries());
//     const data = {};
//     for (let [key, value] of formData.entries()) {
//         data[key] = value;
//     }
//     console.log('data', data);
// }
// form.addEventListener('submit', formOnsubmit);
// }


function Quiz(questions) {
    return {
        step: 0,
        stepUp: function () {
            this.step = this.step + 1 <= questions.length ? this.step + 1 : this.step;
            this.render();
        },
        stepDown: function () {
            this.step = this.step - 1 >= 0 ? this.step - 1 : this.step;
            this.render();
        },
        render: function () {
            if (this.step < questions.length) {
                const currentQuestion = questions[this.step];
                questions.forEach((element) => {
                    element.classList.add('d-none');
                    currentQuestion.classList.remove('d-none');
                })

            } else {
                questions.forEach((element) => {
                    element.classList.add('d-none');
                })
            }

            if (this.step === 0) {
                prevBtn.style.display = 'none';
            } else {
                prevBtn.style.display = 'block';
            }
            if (this.step === questions.length) {
                nextBtn.style.display = 'none';
                submitBtn.style.display = 'block';
                quizInputs.style.display = 'flex';
            } else {
                nextBtn.style.display = 'block';
                submitBtn.style.display = 'none';
                quizInputs.style.display = 'none';
            }
        }

    }
}
let nextBtn = document.querySelector('#next-btn');
let prevBtn = document.querySelector('#prev-btn');
let submitBtn = document.querySelector('#submit-btn'); // default : display none
let quizInputs = document.querySelector('.quiz-form-inputs');
const questions = document.querySelectorAll('.quiz-qus');
const quizSteps = document.querySelectorAll('.quiz-steps');
console.log('questions', questions);
if (questions.length > 0) {
    const quiz = new Quiz(questions);
    quiz.render();
    nextBtn.addEventListener('click', function () {
        quiz.stepUp();
        quiz.render();
        quizSteps[quiz.step].classList.add('active');
    }
    );
    prevBtn.addEventListener('click', function () {
        quizSteps[quiz.step].classList.remove('active');
        quiz.stepDown();
        quiz.render();
    }
    );
}


const form = document.querySelector(".quiz-form")
const formSuccess = document.querySelector(".quiz-form-success-msg")
const formError = document.querySelector(".quiz-form-error-msg")
function formOnsubmit(e) {
    e.preventDefault();
    const formData = new FormData(form);
    // console.log('formData', formData);
    console.log("formData.entries()", formData.entries());
    let data = {
        submissionDate: new Date().toLocaleDateString('en-US')
    };
    for (let [key] of formData.entries()) {
        data[key] = formData.getAll(key);
    }
    // console.log('data', data);
    const fianlData = Object.keys(data).map((key) => {
        data = {
            ...data,
            [key]: data[key].length > 1 ? data[key] : data[key][0]
        }
    })
    // console.log('fianlData', data);
    submitBtn.innerHTML = "Submitting..."
    fetch("https://hooks.zapier.com/hooks/catch/9995233/3rc0w3d/", {
        method: "POST",
        body: JSON.stringify(data)
    }).then(() => {
        submitBtn.innerHTML = "Submit"
        formSuccess.classList.remove('d-none');
    }).catch(() => {
        submitBtn.innerHTML = "Submit"
        formError.classList.remove('d-none');
    }).finally(() => {
        form.reset();
        //     console.log(data)
        location.href="/pages/appointment-booking/?name=" + data.name + '&email=' + data.email + '&phone=' + data.phone;
    }
    )
}
form.addEventListener('submit', formOnsubmit);